export default __webpack_public_path__ + "static/hero_contacto-452c419ec928c7b15ddde8384aafeda1.jpg";